import { Route, Routes } from 'react-router-dom';
import './App.css';
import Aboutme from './pages/Aboutme';
import Blog from './pages/Blog';
import Gdgevents from './pages/Gdgevents';
import Header from './pages/Header';
import Main from './pages/Main';
import Portfolio from './pages/Portfolio';
import Unfind from './pages/Unfind';
import Volunteer from './pages/Volunteer';


function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path='/' element={<Main />} />
        <Route path='/portfolio' element={<Portfolio />} />
        <Route path='/blog' element={<Blog />} />
        <Route path='/volunteering' element={<Volunteer />} />
        <Route path='/about' element={<Aboutme />} />
        <Route path='/gdgevents' element={<Gdgevents />} />
        <Route path='*' element={<Unfind />} />
      </Routes>
    </div>
  );
}

export default App;
